module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/american_express_logo.62485503.svg";